if (!customElements.get('aur-variant-specifications')) {
  customElements.define('aur-variant-specifications', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-aur-spec-list]');
      this.source = JSON.parse(this.querySelector('[data-aur-spec-data]').textContent);
      this.product = this.closest('product-info');
      this.onVariantChange = (event) => {
        if (event.target.matches('input[name="id"]') && this.product?.contains(event.target)) {
          this.renderVariant(event.target.value);
        }
      };
      document.addEventListener('change', this.onVariantChange);
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
    }
    renderVariant(id) {
      const fields = this.source.variants[id]?.[this.dataset.locale];
      if (!fields) {
        this.list.replaceChildren();
        return;
      }
      const fragment = document.createDocumentFragment();
      for (const field of fields) {
        const row = document.createElement('div');
        const label = document.createElement('dt');
        const value = document.createElement('dd');
        label.textContent = this.source.labels[field.key];
        value.textContent = field.value;
        row.append(label, value);
        fragment.append(row);
      }
      this.list.replaceChildren(fragment);
    }
  });
}
